import { render, staticRenderFns } from "./BoundingBoxRepresentation.vue?vue&type=template&id=7ffca4cc"
import script from "./BoundingBoxRepresentation.vue?vue&type=script&lang=js"
export * from "./BoundingBoxRepresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.17.21_prettier@2.8.8_vue-t_9526555e5c4a4a2f93e9ca761d6e387d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports